import type { AllFilters, TFilterSection } from 'types/product-list';
import { getDomainValue } from './domain';
import { sortByNumericKey } from './helpers';

export const filtersMockup = [
  {
    title: 'whats.new',
    id: 'collections',
    mockup: true,
    options: [
      { label: 'Top Sellers', value: 'bestseller' },
      { label: 'Gore-Text', value: 'goretex' },
    ],
  },
  {
    title: 'Tipo',
    id: 'typologies',
    mockup: true,
    options: [
      { label: 'Zapato casual', value: 'casual' },
      { label: 'Zapato de vestir', value: 'casual' },
      { label: 'Sneakers', value: 'casual' },
      { label: 'Botines', value: 'casual' },
      { label: 'Non leather', value: 'casual' },
    ],
  },
  {
    title: 'Lineas',
    id: 'concepts',
    mockup: true,
    options: [
      { label: 'Beetle', value: 'beetle' },
      { label: 'Pelotas', value: 'pelotas' },
      { label: 'Peu', value: 'peu' },
      { label: 'Twins', value: 'twins' },
    ],
  },
  {
    // mirar esto a ver qué podemos hacer que ahora es un caos
    // y cada vez que se cambia una key del back peta todo
    title: 'Línea',
    id: 'lineCollections',
    mockup: true,
    options: [
      { label: 'Beetle', value: 'beetle' },
      { label: 'Pelotas', value: 'pelotas' },
      { label: 'Peu', value: 'peu' },
      { label: 'Twins', value: 'twins' },
    ],
  },
  {
    title: 'Talla',
    id: 'sizes',
    mockup: true,
    options: [
      { label: '37', value: '37' },
      { label: '38', value: '38' },
      { label: '39', value: '39' },
    ],
  },
  {
    title: 'Color',
    id: 'colors',
    mockup: true,
    options: [
      { label: 'Negro', value: 'C01' },
      { label: 'Blanco', value: 'C02' },
      { label: 'Rosa', value: 'C04' },
    ],
  },
  {
    title: 'Precio',
    id: 'prices',
    mockup: true,
    options: [
      { label: '0 - 140€', value: '?' },
      { label: '0 - 170€', value: '?' },
    ],
    solo: true,
  },
  {
    title: 'Sostenibilidad',
    id: 'sustainabilities',
    options: [],
  },
  {
    title: 'Discounts',
    id: 'discounts',
    options: [],
  },
  {
    title: 'Performances',
    id: 'performances',
    options: [],
  },
  {
    title: 'discount.collecction',
    id: 'discountCollections',
    options: [],
    solo: true,
  },
  {
    title: 'Targets',
    id: 'targets',
    options: [],
  },
  {
    title: 'Families',
    id: 'families',
    options: [],
  },
];

export const filtersMap: Record<string, { title: string; id: string; multiple: boolean }> = {
  collections: {
    title: 'whats.new',
    id: 'collections',
    multiple: true,
  },
  typologies: {
    title: 'Tipo',
    id: 'typologies',
    multiple: true,
  },
  concepts: {
    title: 'Lineas',
    id: 'concepts',
    multiple: true,
  },
  lineCollections: {
    title: 'Línea',
    id: 'lineCollections',
    multiple: true,
  },
  sizes: {
    title: 'Talla',
    id: 'sizes',
    multiple: true,
  },
  colors: {
    title: 'Color',
    id: 'colors',
    multiple: true,
  },
  prices: {
    title: 'Precio',
    id: 'prices',
    multiple: false,
  },
  sustainabilities: {
    title: 'Sostenibilidad',
    id: 'sustainabilities',
    multiple: true,
  },
  discounts: {
    title: 'Discounts',
    id: 'discounts',
    multiple: true,
  },
  performances: {
    title: 'Performances',
    id: 'performances',
    multiple: true,
  },
  discountCollections: {
    title: 'discount.collecction',
    id: 'discountCollections',
    multiple: false,
  },
  targets: {
    title: 'Targets',
    id: 'targets',
    multiple: true,
  },
  families: {
    title: 'Families',
    id: 'families',
    multiple: true,
  },
};

// de donde habra que sacar esto? de la api de traducciones o de las labels de la api de productos?
export const labels = {
  prices: ['0 - 140 €', '140 - 170 €', 'More than 170'],
  sustainabilities: ['Recycled styles', 'Better cotton', 'Tencel', 'Better leather', 'Lifetime guarantee', 'Better outsoles', 'Chrome-free linings', 'Wool'],
};

export const sorts = {
  default: getDomainValue({
    camper: 'ordenar.camper',
    nnormal: 'ordenar.nnormal',
    camperlab: 'ordernar.camper',
  }),
  price_asc: 'ordenar.precio.min.max',
  price_desc: 'ordenar.precio.max.min',
};

export const availableSorts = Object.keys(sorts) as TSort[];

// antes se cogia el primero de sorts, pero ahora lo ponemos explicito
export const DEFAULT_SORT = 'default';

export type TSort = keyof typeof sorts;

export const filterGrid = {
  novelties: { gutter: 16, column: 1 },
  targets: { gutter: 16, column: 1 },
  sizes: { gutter: 16, column: 4 },
  default: { gutter: 16, column: 2 },
};

export const tagClassNames = {
  colors: 'colorCheckableTag',
  sizes: 'sizeCheckableTag',
  default: '',
};

export const filterColors = {
  C01: '#000000', // black
  C02: '#ffffff', // white
  C03: '#800080', // purple
  C04: '#f892d6', // pink
  C05: '#8e0000', // burdeos
  C06: '#db2415', // red
  C07: '#2801f6', // blue
  C08: '#ff7000', // orange
  C09: '#e9d8cc', // beige
  C10: '#18b000', // green
  C11: '#783600', // brown
  C12: '#fbe401', // yellow
  C13: '#bcb9b9', // grey
  C14: 'linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)', // multicolor
  C16: '#f3d3b7', // nude
  C17: '#3d3635', // brown grey
};

const filtersOrderArray = [
  'targets',
  'sizes',
  'typologies',
  'concepts',
  'colors',
  'discounts',
  'prices',
  'discountCollections',
  'performances',
  'sustainabilities',
  'qualities',
  'collections',
] as const;

export const filterOrder = Object.fromEntries(filtersOrderArray.map((filter, i) => [filter, i]));

let lastElementIndex = 100;

const hiddenFilters = getDomainValue({
  camper: [] as string[],
  camperlab: ['prices'],
  nnormal: [] as string[],
});

export function createFilterArray(allFilters: AllFilters) {
  return Object.entries(allFilters).reduce((acc, [key, options], i, arr) => {
    if (hiddenFilters.includes(key)) {
      return acc;
    }
    const isLast = i === arr.length - 1;

    const newFilter = {
      title: ['menu.lateral', filtersMap[key]?.title.toLowerCase() ?? key.toLowerCase()] as [string, string],
      id: key,
      multiple: filtersMap[key]?.multiple ?? true,
      options: key === 'prices' ? sortByNumericKey(options) : options,
    };
    let pos = filterOrder[key];
    if (pos < 0) {
      pos = lastElementIndex++;
    }
    acc[pos] = newFilter;

    if (isLast) {
      // remove null values from array
      return acc.filter(Boolean);
    }
    return acc;
  }, [] as TFilterSection[]);
}
